import { distributionRows, sentimentBadgeType } from '@/common/app/modules/media/sentiment'
import { SentimentDistribution } from '@/common/model/media/sentiment'

import Badge from '@/components/view/atoms/badge/Badge'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  distribution: SentimentDistribution
}

// センチメント別の出現率テーブル
const SentimentDistributionTable = ({ distribution }: Props) => (
  <table className='w-full border-collapse'>
    <thead>
      <TableRow head>
        <TableHeadItem type='thin'>
          <Text size={12} color={TextColor.SECONDARY}>
            センチメント
          </Text>
        </TableHeadItem>
        <TableHeadItem type='thin' width={120}>
          <Text size={12} color={TextColor.SECONDARY}>
            出現率
          </Text>
        </TableHeadItem>
      </TableRow>
    </thead>
    <tbody>
      {distributionRows(distribution).map((row) => (
        <TableRow key={row.key}>
          <TableRowItem align='middle'>
            <Badge size={12} badgeType={sentimentBadgeType(row.key)}>
              {row.label}
            </Badge>
          </TableRowItem>
          <TableRowItem width={128} align='middle'>
            <Text size={14}>{row.value}%</Text>
          </TableRowItem>
        </TableRow>
      ))}
    </tbody>
  </table>
)

export default SentimentDistributionTable
